module.exports = __webpack_public_path__ + "static/img/logo_21.87611fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_21.png
// module id = vZqT
// module chunks = 1